module.exports = __webpack_public_path__ + "static/media/place-4.a9bb61e8.jpg";